export const ACCEPTED_FILE_TYPES = {
  pdf: true,
  png: true,
  jpg: true,
  jpeg: true,
} as const;
